<div itaxToggleCheckbox class="d-flex align-items-center pointer" [ngClass]="cssClass">
  <div class="custom-control custom-checkbox" [ngClass]="{'required': warning}">
    <input type="checkbox" class="custom-control-input"
           [readonly]="readonly"
           [disabled]="readonly"
           [id]="id"
           [checked]="checked"
           (change)="onCheckChange()"
    />
    <label class="custom-control-label disabled" [for]="id" [ngClass]="{'required': warning}">
    </label>
  </div>
  <div class="wrap-label text-nowrap">
    <span class="wrap-text" [ngStyle]="{'width': labelWidth > 0 ? labelWidth+'px': 'auto'}">{{label}}</span>
    <ng-content></ng-content>
  </div>
</div>
